module.exports = __webpack_public_path__ + "img/AI.d7e78775.png";